export default "__VITE_ASSET__Bdk9FVkM__"